import { INITIAL_STATE } from './state';
import { NotificationActions, } from './types';
export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case NotificationActions.SHOW_NOTIFICATION: {
            return showNotification(payload);
        }
        case NotificationActions.HIDE_NOTIFICATION: {
            return hideNotification(state);
        }
        case NotificationActions.CLEAR_NOTIFICATION: {
            return clearNotification();
        }
        default:
            return state;
    }
};
function showNotification(payload) {
    return {
        ...payload,
        isVisible: true,
    };
}
function hideNotification(state) {
    return {
        ...state,
        isVisible: false,
    };
}
function clearNotification() {
    return {
        ...INITIAL_STATE,
    };
}
